import { View } from "react-native";
import { useDatastore } from "util/datastore";
import { useEffect } from "react";
import type { Feature } from "util/stdtypes";
import type { QuestionConfig } from "structure/question";

export const ArticleTopicTaggingFeature: Feature<QuestionConfig, {}> = {
    name: 'Tag Article Topics',
    key: 'articletopictagging',
    providesConfig: {
        topBanners: [IndexWidget]
    }
};

// Invisible Widget which tags an article on open
export function IndexWidget(): JSX.Element {

    const datastore = useDatastore();

    useEffect(() => {

        const getTags = async () => {
            let response = await datastore.callServerAsync('interests', 'getArticleTopics');
            const emptyArr: any[] = [];
            if(!response || response == emptyArr){
                response = datastore.callServerAsync('interests', 'determineArticleTopics');
            }
        }
        getTags()
    }, [])

    return <View></View>
}
